import axios from 'axios'

const API_PREFIJO = 'tienda/galeria'

export default {
    consultarCantidadImagenes: () => axios(`${API_PREFIJO}/contador-imagenes`),
    consultarGaleriaImagenes: params => axios(`${API_PREFIJO}/listado-imagenes`, { params }),
    guardarImagen: payload => axios.post(`${API_PREFIJO}/guardar-imagen`, payload),
    eliminarImagen: payload => axios.delete(`${API_PREFIJO}/${payload}/eliminar-imagen`),
}